export enum RouteParamTypesEnum {
  LANG = 'lang',
  PRODUCT = 'product',
  TAB = 'tab',
  ID = 'id',
  SLUG = 'slug',
  TOKEN = 'token',
  LANDING_SLUG = 'landing-slug',
}
